"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalMU = void 0;
var R = __importStar(require("ramda"));
var Cores_1 = require("./componentes/Cores/Cores");
exports.globalMU = {
    formatarValorNumerico: function (valor, numeroCasasDecimais, exibirSimboloMonetario) {
        if (exibirSimboloMonetario === void 0) { exibirSimboloMonetario = false; }
        var numeroCasasDecimaisAjustado = numeroCasasDecimais == null || isNaN(numeroCasasDecimais)
            ? 2
            : numeroCasasDecimais;
        return new Intl.NumberFormat("pt-BR", {
            minimumFractionDigits: numeroCasasDecimaisAjustado,
            maximumFractionDigits: numeroCasasDecimaisAjustado,
            currency: exibirSimboloMonetario ? "BRL" : undefined,
            style: exibirSimboloMonetario ? "currency" : "decimal",
        }).format(valor !== null && valor !== void 0 ? valor : 0);
    },
    isNullOrEmpty: function (value) {
        return R.isNil(value) || R.isEmpty(value);
    },
    isNotNullOrEmpty: function (value) {
        return !this.isNullOrEmpty(value);
    },
    isNullOrEmptyOrUndefined: function (value) {
        return value === undefined || this.isNullOrEmpty(value);
    },
    isNotNullOrEmptyOrUndefined: function (value) {
        return !this.isNullOrEmptyOrUndefined(value);
    },
    escapeRegExp: function (string) {
        return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    },
    validateEmail: function (email) {
        var filter = /^([\w-.]+)@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.)|(([\w-]+.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(]?)$/;
        if (filter.test(email)) {
            return true;
        }
        else {
            return false;
        }
    },
    replaceAll: function (str, find, replace) {
        if (!str) {
            return null;
        }
        return str.replace(new RegExp(exports.globalMU.escapeRegExp(find), "g"), replace);
    },
    // formato dd/mm/aaaa
    validarData: function (data) {
        if (data.length < 10)
            return false;
        var _a = data.split("/").map(Number), day = _a[0], month = _a[1], year = _a[2];
        var date = new Date(year, month - 1, day);
        if (date.getDate() !== day ||
            date.getMonth() !== month - 1 ||
            date.getFullYear() !== year)
            return false;
        return true;
    },
    formatarTelefone: function (valor) {
        //Formata telefone no paadrao Braiseleiro (DDD) 99 9999-9999 ou (DDD) 99 99999-9999 
        // e 099 9999-9999 ou  099 99999-9999
        var numero = valor.replace(/\D/g, '');
        var ddi = null;
        if (valor && numero.startsWith("55")) {
            ddi = numero.slice(0, 2);
            numero = numero.slice(2);
        }
        if (numero.startsWith('0') && numero.length > 10) {
            numero = numero.slice(1);
        }
        if (numero.length < 3)
            return numero;
        var ddd = numero.slice(0, 2);
        var restante = numero.slice(2);
        var formatado = "(".concat(ddd);
        if (numero.length >= 3)
            formatado += ") ";
        if (restante.length <= 4) {
            formatado += restante;
        }
        else if (restante.length <= 8) {
            formatado += "".concat(restante.slice(0, 4), "-").concat(restante.slice(4));
        }
        else {
            formatado += "".concat(restante.slice(0, 5), "-").concat(restante.slice(5, 9));
        }
        if (ddi) {
            return "+".concat(ddi, " ").concat(formatado);
        }
        return formatado;
    },
    //valida apennas telefones brasileiros  
    validarTelefone: function (valor) {
        // Deve conter apenas números
        if (!/^\d+$/.test(valor))
            return false;
        var numeros = valor;
        // ignora o DDI, se existir
        if (numeros.startsWith('55')) {
            numeros = numeros.slice(2);
        }
        // ignora o zero inicial do DDD, se existir
        if (numeros.startsWith('0')) {
            numeros = numeros.slice(1);
        }
        // Deve ter 10 ou 11 dígitos agora
        if (numeros.length !== 10 && numeros.length !== 11)
            return false;
        var ddd = numeros.slice(0, 2);
        // DDD deve estar entre 11 e 99
        if (!/^[1-9][1-9]$/.test(ddd))
            return false;
        // Número válido, não importa se é fixo ou celular
        return true;
    },
    formatarData: function (data, formatoData) {
        var dia = String(data.getDate()).padStart(2, '0');
        var mes = String(data.getMonth() + 1).padStart(2, '0');
        var ano = String(data.getFullYear());
        switch (formatoData) {
            case 'dd/mm/aaaa':
                return "".concat(dia, "/").concat(mes, "/").concat(ano);
            case 'dd/mm/aa':
                return "".concat(dia, "/").concat(mes, "/").concat(ano.slice(-2));
            case 'mm/aaaa':
                return "".concat(mes, "/").concat(ano);
            case 'mm/aa':
                return "".concat(mes, "/").concat(ano.slice(-2));
            default:
                return '';
        }
    },
    isDeepEqual: function (a, b) {
        if (a === b)
            return true;
        if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) {
            return false;
        }
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length)
            return false;
        for (var _i = 0, keysA_1 = keysA; _i < keysA_1.length; _i++) {
            var key = keysA_1[_i];
            if (!keysB.includes(key) || !this.isDeepEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    },
    formatarMilhar: function (valor) {
        var _a = valor.split(","), parteInteira = _a[0], _b = _a[1], parteDecimal = _b === void 0 ? "" : _b;
        var adicionarSeparadorMilhar = function (parteInteira) {
            return parteInteira.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        };
        var parteInteiraComMilhar = adicionarSeparadorMilhar(parteInteira);
        return parteDecimal.length > 0
            ? "".concat(parteInteiraComMilhar, ",").concat(parteDecimal)
            : parteInteiraComMilhar;
    },
    removerMilhar: function (valor) {
        return valor.replace(/\./g, "");
    },
    localStorage: {
        getData: function (key) {
            var data = localStorage.getItem(key);
            if (!data) {
                return null;
            }
            return JSON.parse(data);
        },
        setData: function (key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        },
        removeData: function (key) {
            localStorage.removeItem(key);
        },
    },
    formatarTelemetria: function (telemetria) {
        if (!telemetria)
            return "Não disponível";
        var mensagemErro = telemetria.mensagemErro, data = telemetria.data, rota = telemetria.rota, parametros = telemetria.parametros, respostaServidor = telemetria.respostaServidor;
        var resultado = [
            mensagemErro && "Mensagem do Erro: ".concat(mensagemErro),
            data && "   Data Original: ".concat(data),
            rota && "   Rota: ".concat(rota),
        ].filter(Boolean).join('\n');
        var parametrosFormatados = function (label, arr) {
            return (arr === null || arr === void 0 ? void 0 : arr.length)
                ? "  ".concat(label, ":\n") + arr.map(function (p, i) { return "    [".concat(i + 1, "] ").concat(JSON.stringify(p, null, 6).replace(/\n/g, '\n   ')); }).join(',\n') + '\n\n'
                : '';
        };
        if (parametros) {
            resultado += "\n\nParâmetros da Requisição:\n";
            resultado += parametrosFormatados(" Query Parameters", parametros.query || []);
            resultado += parametrosFormatados(" Body Parameters", parametros.body || []);
            if (respostaServidor) {
                resultado += "\n    Resposta do Servidor:\n";
                if (respostaServidor.status)
                    resultado += "  Status: ".concat(respostaServidor.status, "\n");
                if (respostaServidor.data)
                    resultado += "  Data:".concat(respostaServidor.data, "\n");
            }
        }
        return resultado.trim() || "Dados de telemetria não disponíveis";
    },
    filtrarStackTrace: function (mensagem, repositorio) {
        if (!mensagem)
            return "";
        var stackTraceIndex = mensagem.indexOf("StackTrace:");
        if (stackTraceIndex === -1)
            return mensagem;
        var mainMessage = mensagem.substring(0, stackTraceIndex).trim();
        var stackTrace = mensagem.substring(stackTraceIndex + 11).trim();
        var relevantStackLines = stackTrace
            .split(" at ")
            .filter(function (line) {
            return line.includes(".cs:line") ||
                line.includes("/".concat(repositorio, "/"));
        })
            .join("\n at ");
        return "".concat(mainMessage, "\n\nStackTrace:\n at ").concat(relevantStackLines);
    },
    getCor: function (_a) {
        var desabilitado = _a.desabilitado, tipoEstilo = _a.tipoEstilo, variante = _a.variante;
        if (desabilitado)
            return Cores_1.Cores.GradacaoNeutros.CinzaFillMU400;
        if (tipoEstilo === 'default') {
            if (variante === 'success')
                return Cores_1.Cores.MensagensDoSistema.VerdeMU;
            if (variante === 'error')
                return Cores_1.Cores.MensagensDoSistema.VermelhoMU;
            return Cores_1.Cores.GradacaoNeutros.CinzaFillMU600;
        }
        if (tipoEstilo === 'filled') {
            if (variante === 'success')
                return Cores_1.Cores.MensagensDoSistema.VerdeMU;
            if (variante === 'error')
                return Cores_1.Cores.MensagensDoSistema.VermelhoMU;
            return Cores_1.Cores.GradacaoNeutros.BrancoMU50;
        }
        return Cores_1.Cores.GradacaoNeutros.CinzaFillMU600;
    }
};
exports.default = exports.globalMU;
